import { FireStoreModule } from 'fb/index';
import { collection, Firestore } from 'firebase/firestore';
import { updateEditions, updatePublications } from 'store/data/publications/actions';

export class PublicationsFireStoreModule implements FireStoreModule {
	public getModuleName = () => 'publications';
	public getOpsKeySuffix = () => 'global';
	public getFBWatchQuery = (db: Firestore) => collection(db, 'publications');
	public getChangeProcessAction = (changes) => updatePublications(changes);
}

export class EditionsFireStoreModule implements FireStoreModule {
	public getModuleName = () => 'editions';
	public getOpsKeySuffix = () => 'global';
	public getFBWatchQuery = (db: Firestore) => collection(db, 'editions');
	public getChangeProcessAction = (changes) => updateEditions(changes);
}
